import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import EditVehicleForm from './EditVehicleForm';

const EditVehicleDialog = ({ open, onOpenChange, vehicle, onUpdateVehicle }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (vehicleData) => {
    setIsSubmitting(true);
    try {
      await onUpdateVehicle(vehicleData);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
     <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Edit Vehicle</DialogTitle>
        </DialogHeader>
        <EditVehicleForm 
          vehicle={vehicle} 
          onSubmit={handleSubmit} 
          isSubmitting={isSubmitting} 
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditVehicleDialog;